import React from "react";
import Elv3Stepper from "./components/Elv3Stepper";
import { HeadersProvider } from "./HeadersContext";
import { useSelector } from "react-redux";
import { selectNavHeight } from "../../../../../redux/navbar/navHeightSlice";

const CreateElv3 = () => {
  return (
    <div
      className="mx-auto w-full"
      style={{
        marginTop: useSelector(selectNavHeight),
        height: `calc(100vh - ${useSelector(selectNavHeight)}px)`,
        overflow: "auto",
      }}
    >
      <HeadersProvider>
        <div className="p-4 w-full">
          <Elv3Stepper />
        </div>
      </HeadersProvider>
    </div>
  );
};

export default CreateElv3;
